module.exports = __webpack_public_path__ + "static/Thumb_NC1_TVScreen_comp-d17a0380b96755f10d354966b1e9c710.png";